// extracted by mini-css-extract-plugin
module.exports = {"appSwitcher":"_1e01HvmnxECEXmEf28SOWO"};